import PropTypes from 'prop-types';
import React from 'react';

import Container from '@glass/web/components/Layout/Container';
import { MD, SM } from '@glass/web/modules/theme/breakpointKeys';
import { CENTER } from '@glass/web/modules/theme/constants';
import makeStyles from '@glass/web/modules/theme/makeStyles';

import ConsumerLayoutPage from '@glass/shared/components/Layout/ConsumerLayoutPage';
import MiniFooter from '@glass/shared/components/Layout/Footer/MiniFooter';

const useStyles = makeStyles()((theme) => ({
  footerFiller: {
    [theme.breakpoints.down(MD)]: {
      opacity: 0,
    },
    [theme.breakpoints.down(SM)]: {
      minHeight: 73,
    },
  },
}));

function BuilderFooter() {
  const { classes } = useStyles();
  return (
    <div className={classes.footerFiller}>
      <MiniFooter />
    </div>
  );
}

const headerProps = {
  minimal: true,
  search: false,
  position: 'static',
  transparent: false,
};

function BuilderLayoutPage({ children, header, footer, type, robots }) {
  return (
    <ConsumerLayoutPage
      hideZendesk
      footer={footer}
      header={header}
      headerProps={headerProps}
      robots={robots}
      type={type}
    >
      <Container>{children}</Container>
    </ConsumerLayoutPage>
  );
}

BuilderLayoutPage.propTypes = {
  children: PropTypes.node,
  footer: PropTypes.node,
  header: PropTypes.node,
  robots: PropTypes.string,
  type: PropTypes.oneOf([CENTER]),
};

BuilderLayoutPage.defaultProps = {
  footer: <BuilderFooter />,
};

export default React.memo(BuilderLayoutPage);
